import { z } from 'zod';
import { dateStringSchema } from './dateString.js';
export const handoffInvoiceSchema = z.object({
    externalId: z.string(),
    docNumber: z.string().optional(),
    dueDate: dateStringSchema,
    amount: z.number(),
});
export const handoffLeftTemplateSchema = z.object({
    templateId: z.string(),
    name: z.string().optional(),
});
export const handoffBillingSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('not_billed') }),
    z.object({
        kind: z.literal('moved'),
        firstDueDate: dateStringSchema,
        voided: z.array(handoffInvoiceSchema),
        keptPaid: z.array(handoffInvoiceSchema),
    }),
    z.object({ kind: z.literal('by_hand') }),
]);
const templatesLeftSchema = z.array(handoffLeftTemplateSchema);
export const previousCustomerSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('deactivated') }),
    z.object({ kind: z.literal('in_use') }),
    z.object({ kind: z.literal('template_left') }),
    z.object({ kind: z.literal('templates_unread') }),
    z.object({ kind: z.literal('left_active'), openBalance: z.number() }),
]);
export const ownerHandoffSchema = z.discriminatedUnion('stage', [
    z.object({ stage: z.literal('requested') }),
    z.object({
        stage: z.literal('planned'),
        billing: handoffBillingSchema,
        stampIds: z.array(z.string()),
        templatesLeft: templatesLeftSchema,
    }),
    z.object({
        stage: z.literal('billing_moved'),
        billing: handoffBillingSchema,
        templatesLeft: templatesLeftSchema,
    }),
    z.object({
        stage: z.literal('completed'),
        billing: handoffBillingSchema,
        templatesLeft: templatesLeftSchema,
        previousCustomer: previousCustomerSchema,
    }),
]);
export const unitSaleSummarySchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('none') }),
    z.object({
        kind: z.literal('in_progress'),
        previousOwnerName: z.string(),
        newOwnerName: z.string(),
        soldOn: dateStringSchema,
    }),
    z.object({
        kind: z.literal('completed'),
        previousOwnerName: z.string(),
        newOwnerName: z.string(),
        soldOn: dateStringSchema,
        billing: handoffBillingSchema,
        templatesLeft: templatesLeftSchema,
        previousCustomer: previousCustomerSchema,
    }),
]);
export const earlierOwnerOwingSchema = z.object({
    ownerName: z.string(),
    openBalance: z.number(),
});
//# sourceMappingURL=ownerHandoff.js.map